import { render, staticRenderFns } from "./UpdateProductOrderInvoicePopUp.vue?vue&type=template&id=08513b92&scoped=true&"
import script from "./UpdateProductOrderInvoicePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateProductOrderInvoicePopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductOrderInvoicePopUp.vue?vue&type=style&index=0&id=08513b92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08513b92",
  null
  
)

export default component.exports